<template>
  <div>
    <Head title="Mutasi Item Asset" />
    <h1 class="mb-8 text-3xl font-bold">
      Inventaris
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/item_assets">
        Item Asset
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/item_assets/${itemAsset.id}/edit`">
        {{ props.itemAsset.item_name }}
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      Mutasi
    </h1>
    <div class="max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <div id="sectionHeader">
        <div id="sectionEx" class="px-6 py-4 max-w-4xl bg-white rounded-md shadow overflow-hidden">
          <a
            class="text-ellipsis hover:bg-blue-50 flex items-center justify-between mb-3 py-2 whitespace-nowrap rounded cursor-pointer overflow-hidden transition duration-300 ease-in-out"
            data-mdb-ripple="true"
            data-mdb-ripple-color="primary"
            data-bs-toggle="collapse"
            data-bs-target="#collapsesectionEx"
            aria-expanded="false"
            aria-controls="collapsesectionEx">
            <span class="text-xl font-bold">Detail Info Asset {{ props.itemAsset.item_name }} [{{ props.itemAsset.asset_no }}] </span>
            <Icon icon="fa6-solid:chevron-down" class="ml-1 w-8 h-8 fill-gray-500" />
          </a>
          <ul
            id="collapsesectionEx"
            class="accordion-collapse collapse relative"
            aria-labelledby="sectionEx"
            data-bs-parent="#sectionHeader">
            <div class="flex flex-wrap p-2">
              <text-input
                :model-value="props.itemAsset.item_name"
                class="pb-8 pr-6 w-1/2"
                label="Nama Barang"
                disabled />
              <text-input
                :model-value="props.itemAsset.asset_no"
                class="pb-8 pr-6 w-1/2"
                label="No. Inventaris"
                disabled />
              <text-input
                :model-value="props.itemAsset.barcode01"
                class="pb-8 pr-6 w-1/2"
                label="Barcode 01"
                disabled />
              <text-input
                :model-value="props.itemAsset.barcode02"
                class="pb-8 pr-6 w-1/2"
                label="Barcode 02"
                disabled />
              <text-input
                :model-value="props.itemAsset.condition"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Barcode 02"
                disabled />
              <text-input
                :model-value="props.itemAsset.status"
                input-class="font-bold text-center"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Status Asset"
                disabled />
              <text-input
                :model-value="props.itemAsset.asset_ownership"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Asset Ownership"
                disabled />
              <text-input
                :model-value="props.itemAsset.project_name"
                class="pb-8 pr-6 w-full md:w-1/3"
                label="Sumber Data (Project)"
                disabled />
              <text-input
                :model-value="props.itemAsset.employee_name"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Penanggung Jawab"
                disabled />
              <text-input
                :model-value="props.itemAsset.item_location_name"
                class="pb-8 pr-6 w-1/2 md:w-1/3"
                label="Lokasi Item"
                disabled />
              <div class="pb-8 pr-6 w-full md:w-1/2">
                <label class="form-label">Harga Beli:</label>
                <number-input :value="props.itemAsset.purchase_price" disabled />
              </div>
              <div class="pb-8 pr-6 w-full md:w-1/3">
                <label class="form-label">Perkiraan Depresiasi Tahunan:</label>
                <number-input :value="props.itemAsset.depreciation_rate" disabled />
              </div>
              <textarea-input
                :model-value="props.itemAsset.desc"
                label="Deskripsi Asset"
                class="pb-8 pr-6 w-full md:w-1/2"
                readonly />
              <text-input
                :model-value="props.itemAsset.purchase_date"
                input-class="text-center"
                label="Tanggal Pengadaan"
                class="pb-8 pr-6 w-full md:w-1/3"
                disabled />
            </div>
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-2 max-w-4xl bg-white rounded-md shadow overflow-hidden">
      <div class="px-6 py-4">
        <span class="text-xl font-bold">Tindakan Mutasi (Tambah Baru)</span>
      </div>
      <form @submit.prevent="submitMutasi">
        <div class="flex flex-wrap -mr-6 px-8 py-2">
          <select-input
            v-model="form.asset_event_id"
            :error="form.errors.asset_event_id"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Jenis Event">
            <option :value="null" disabled>
              [ PILIH ]
            </option>
            <option
              v-for="event in assetEvents"
              :key="event.id"
              :value="event.id"
              :title="event.desc">
              {{ event.name }}
            </option>
          </select-input>
          <div class="flex flex-col pb-8 pr-6 w-full md:w-1/3">
            <label>Tanggal Mutasi:</label>
            <flat-pickr v-model="form.event_date" class="dtp-line mt-2 p-2 w-full text-center border rounded" />
            <div v-if="form.errors.event_date" class="form-error">
              {{ form.errors.event_date }}
            </div>
          </div>
          <template v-if="form.asset_event_id === 4">
            <div class="w-full" />
            <text-input
              :model-value="props.itemAsset.item_location_name"
              class="pb-8 pr-6 w-1/2 md:w-1/3"
              label="Lokasi Asal"
              disabled />
            <select-input
              v-model="form.item_location_id"
              :error="form.errors.item_location_id"
              class="pb-8 pr-6 w-full md:w-1/3"
              label="Lokasi Tujuan">
              <option
                v-for="itemLocation in itemLocations"
                :key="itemLocation.id"
                :value="itemLocation.id">
                {{ itemLocation.name }}
              </option>
            </select-input>
          </template>
          <template v-if="form.asset_event_id === 3">
            <div class="w-full" />
            <text-input
              :model-value="props.itemAsset.employee_name"
              class="pb-8 pr-6 w-1/2 md:w-1/3"
              label="Dari"
              disabled />
            <select-input
              v-model="form.employee_id"
              :error="form.errors.employee_id"
              class="pb-8 pr-6 w-1/2 md:w-1/3"
              label="Kepada">
              <option
                v-for="employee in employees"
                :key="employee.id"
                :value="employee.id">
                {{ employee.name }}
              </option>
            </select-input>
          </template>
          <div class="w-full" />
          <textarea-input
            v-model="form.desc"
            :error="form.errors.desc"
            label="Penjelasan terkait mutasi"
            class="pb-8 pr-6 w-full md:w-2/3"
            rows="4" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button
            :loading="form.processing"
            class="btn-red"
            type="submit">
            Submit Mutasi
          </loading-button>
        </div>
      </form>
    </div>
    <div class="mt-2 max-w-5xl bg-white rounded-md shadow overflow-hidden">
      <div class="px-6 py-4">
        <span class="text-xl font-bold">List History Mutasi</span>
      </div>
      <div class="flex flex-wrap px-6 py-4">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="p-4">
                Tanggal Event
              </th>
              <th class="p-4">
                Jenis Event
              </th>
              <th class="p-4">
                Keterangan
              </th>
              <th class="p-4" colspan="2">
                Operator
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="log in logAssets.data"
              :key="log.id"
              class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="px-4 py-2 w-1/4 border-t">
                {{ log.event_date }}
              </td>
              <td class="px-4 py-2 w-1/4 border-t">
                {{ log.asset_event_name }}
              </td>
              <td class="px-4 py-2 w-2/4 whitespace-normal border-t">
                <multiline-text :text="log.desc" />
              </td>
              <td class="px-4 py-2 w-1/4 border-t">
                {{ log.operator_name }}
              </td>
              <td class="px-4 py-2 w-1/4 border-t">
                <Link
                  type="button"
                  as="button"
                  title="View/Add Attached Docs"
                  :href="`/log_assets/${log.id}/edit`">
                  <Icon icon="ic:outline-attach-email" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="logAssets.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="5">
                No Log Event found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        class="mt-6"
        :links="logAssets.links"
        with-per-page />
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue'

export default {
    layout: Layout,
}
</script>

<script setup>
import { Head, Link, useForm } from '@inertiajs/vue3'
import { defineProps } from 'vue'
import { Icon } from '@iconify/vue'
import SelectInput from '@/Shared/SelectInput.vue'
import TextInput from '@/Shared/TextInput.vue'
import TextareaInput from '@/Shared/TextareaInput.vue'
import NumberInput from '@/Shared/NumberInput'
import LoadingButton from '@/Shared/LoadingButton.vue'
import Pagination from '@/Shared/Pagination.vue'
import MultilineText from '@/Shared/MultilineText.vue'
import flatPickr from 'vue-flatpickr-component'
import 'vue-select/dist/vue-select.css'
import 'flatpickr/dist/flatpickr.css'

const props = defineProps({
    itemAsset: Object,
    logAsset: Object,
    logAssets: Object,
    assetEvents: Array,
    employees: Array,
    itemLocations: Array,
})

const form = useForm({
    ...props.logAsset,
    origin_location_id: props.itemAsset.item_location_id,
    origin_employee_id: props.itemAsset.employee_id,
})

const submitMutasi = () => {
    form.post(`/item_assets/${props.itemAsset.id}/mutasi`, {
        preserveScroll: true,
        onSuccess: () => form.reset(),
    })
}
</script>

<style scoped>
.dtp-line {
  line-height: 1.5;
}
.tr-line {
  line-height: 1.25;
}
</style>
